import { intersect, literal, string, struct, union } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { TransactionId as StageId } from '../../../job/stage/Id';
import { Id as StatusId } from '../../../job/status/Id';
import { Id as TransactionId } from '../../../transaction/Id';
import { Id as UserId } from '../../../user/Id';

const SetOwnerUpdate = struct({
	type: literal('set-owner'),
	userId: UserId,
});

const AssignStageUpdate = struct({
	type: literal('assign-stage'),
	stageId: StageId,
	userId: UserId,
});

const ChangeStageStatusUpdate = struct({
	type: literal('change-stage-status'),
	stageId: StageId,
	status: StatusId,
});

const EditNoteUpdate = struct({
	type: literal('edit-note'),
	value: string,
});

const RequestUpdate = intersect(
	struct({
		transactionId: TransactionId,
	})
)(union(SetOwnerUpdate, AssignStageUpdate, ChangeStageStatusUpdate, EditNoteUpdate));

export const Request = struct({
	updates: iotsUtils.NonEmptyArray(RequestUpdate),
});
